import React, { useState } from 'react';
import ActivityLoader from '../../Common/ActivityLoader';
import BsModal from '../../Common/BsModal';
import ajaxConfig from '../../../util/remote/ajaxConfig';
import { useTheme } from '../../../DataStore/ThemeContext';
import Notification from '../../Common/Notification';
import { usePermission } from '../../../DataStore/PermissionContext';
import ajaxAuth from '../../../util/remote/ajaxAuth';

const AlertRevokePermission = () => {

    const [loading, setLoading] = useState(false);
    const {setNotify} = useTheme();

    const { accessRevoke, setAccessRevoke } = usePermission();

    const handleClose = () => setAccessRevoke({ show: false, accessIds: null });


   if (!accessRevoke.accessIds) return null;
  
   

    const confirm = async()=>{
        setLoading(true);
        const server_response = await ajaxAuth.revokeMultiPermissions({access_ids: accessRevoke.accessIds});
        setLoading(false);
        if(server_response.status === "OK"){
            accessRevoke.callback();
            setNotify(<Notification type='success' message={server_response.message}/>)
        }else{
            setNotify(<Notification type='danger' message={server_response.message}/>)

        }
        handleClose();
    }

    return (
        <BsModal
            show={accessRevoke.show}
            onClose={handleClose}
            title="Revoke Role Permissions"
            footer={
                <>
                    {loading && <ActivityLoader />}
                    {!loading && <>
                    <button className="btn btn-secondary" onClick={handleClose}>
                        Cancel
                    </button>
                    <button className="btn btn-danger" onClick={confirm}>
                        Revoke Permissions
                    </button>
                    </>}
                </>
            }
        >


            {accessRevoke.accessIds && <div className="d-flex justify-content-center align-items-center flex-column">
                <i 
                className="fa fa-question-circle text-danger" 
                style={{ fontSize: "40px", lineHeight: "1", marginTop: "20px" }}
                ></i>
                <h5 className='mt-1 text-dark text-center' style={{fontSize: '17px'}}>Please confirm that you want to revoke the selected role permissions.</h5>

                <p className="mb-4 mt-2 text-secondary">
                <b>Note: </b>All users with this role will lose the permissions associated with it.
                </p>
           
            </div>}
          

        </BsModal>
    );
};

export default AlertRevokePermission;
